import axios from 'axios';
import config from '../config/api';

// Une session par onglet, distincte du compte Supabase des agents. Le secret
// n'est jamais placé dans une URL, location.state, un cookie public ou les logs.
const key = 'cgci.checkout.v1';
const client = axios.create({ baseURL: config.apiUrl, timeout: 60000 });
let creating;
function readSession() {
  try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
}
async function session(create) {
  const existing = readSession();
  if (existing?.token && Date.parse(existing.expiresAt) > Date.now()) return existing;
  if (existing?.token || !create) throw new Error('La session de commande a expiré. Contactez le consulat avec votre référence de paiement.');
  if (!creating) {
    creating = client.post('/api/checkouts').then(({ data }) => {
      sessionStorage.setItem(key, JSON.stringify(data));
      return data;
    }).finally(() => { creating = null; });
  }
  return creating;
}
async function request(method, url, data, options = {}) {
  const current = await session(options.create || false);
  return client.request({ method, url, data, responseType: options.responseType,
    headers: { Authorization: `Checkout ${current.token}` } });
}

const checkout = {
  prepare: data => request('post', '/api/checkout/prepare', data, { create: true }),
  complete: transaction_id => request('post', '/api/checkout/complete', { transaction_id }),
  current: () => request('get', '/api/checkout'),
  email: transaction_id => request('post', '/api/checkout/email', { transaction_id }),
  document: async (kind, transaction_id) => {
    const response = await request('get', `/api/checkout/documents/${kind}?transaction_id=${encodeURIComponent(transaction_id)}`,
      undefined, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
  },
  // Une commande terminée reste disponible sur Confirmation ; le prochain
  // passage sur Payment peut commencer un autre dossier dans le même onglet.
  newOrder: () => { sessionStorage.removeItem(key); }
};

export default checkout;
